var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import "oj-event";
import { cleanString, debounce } from "oj-utils";
import { getTransitionDuration, isAcceptable } from "oj-dom-utils";
import m from "mithril";
export var getAttrValue = function (val) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return typeof val === "function" ? val.apply(void 0, __spread(args)) : val;
};
export var keyOrIndex = function (x, i) { var _a, _b; return (_b = (_a = x === null || x === void 0 ? void 0 : x.attrs) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : i; };
export var immediate = function (component, options) {
    if (options === void 0) { options = {}; }
    var resolver;
    var rejector;
    var promise = new Promise(function (res, rej) { resolver = res, rejector = rej; });
    var distroy = function () {
        var _a;
        return setTimeout(function () {
            m.mount(root, null);
            try {
                document.body.removeChild(root);
            }
            catch (e) {
            }
        }, (_a = options.distroyTimeout) !== null && _a !== void 0 ? _a : 1000);
    };
    var resolve = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        resolver.apply(void 0, __spread(args));
        distroy();
    };
    var reject = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        rejector.apply(void 0, __spread(args));
        distroy();
    };
    var root;
    if (options.root)
        root = options.root;
    else {
        root = document.createElement("div");
        document.body.appendChild(root);
    }
    m.mount(root, component);
    return {
        promise: promise,
        resolve: resolve,
        reject: reject,
    };
};
export var withAttrs = function (vnode, attrs, mutator) {
    if (!vnode.attrs)
        vnode.attrs = {};
    var _loop_1 = function (k) {
        if (typeof attrs[k] === "function") {
            var fn_1 = vnode.attrs[k];
            vnode.attrs[k] = function () {
                var res = [];
                res.push(attrs[k].apply(this, arguments));
                if (typeof fn_1 === "function")
                    res.push(fn_1.apply(this, arguments));
                if (k === "onbeforeremove")
                    return Promise.all(res);
                else if (k === "onbeforeupdate")
                    return res[0] !== undefined ? res[0] : res[1] !== undefined ? res[1] : undefined;
                return res;
            };
        }
        else {
            vnode.attrs[k] = typeof mutator === "function" ? mutator(k, vnode.attrs[k], attrs[k]) : attrs[k];
        }
    };
    for (var k in attrs) {
        _loop_1(k);
    }
    return vnode;
};
export var onbeforeremoveAll = function (v) {
    if (Array.isArray(v))
        return Promise.all(v.map(function (x) { return onbeforeremoveAll(x); }));
    if (typeof v !== "object" || v === null)
        return Promise.resolve();
    if (!v.attrs)
        v.attrs = {};
    var p = [];
    if (v && v.attrs && typeof v.attrs.onbeforeremove === "function" && v.attrs.onbeforeremove !== onbeforeremoveAll)
        p.push(v.attrs.onbeforeremove.call(v.state, v));
    if (v && v.state && typeof v.state.onbeforeremove === "function" && v.state.onbeforeremove !== onbeforeremoveAll)
        p.push(v.state.onbeforeremove.call(v.state, v));
    p.push(onbeforeremoveAll(v.children));
    return Promise.all(p);
};
export var vnodeWalker = function (v, validator, maxDepth, depth) {
    var e_1, _a;
    if (depth === void 0) { depth = 0; }
    var nodes = [];
    if (v.tag === "#")
        return nodes;
    if (maxDepth !== undefined && depth >= maxDepth)
        return nodes;
    if (typeof validator !== "function" || validator(v) === true)
        nodes.push(v);
    if (Array.isArray(v.children))
        try {
            for (var _b = __values(v.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var vc = _c.value;
                nodes = nodes.concat(vnodeWalker(vc, validator, maxDepth, depth + 1));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    return nodes;
};
export var flattenChildren = function (children) {
    var e_2, _a;
    var arr = [];
    try {
        for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
            var c = children_1_1.value;
            if (!c)
                arr.push(c);
            else if (c.tag === "[")
                arr = arr.concat(c.children);
            else
                arr.push(c);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return arr;
};
export var cloneVNode = function (vnode) {
    if (Array.isArray(vnode))
        return vnode.map(function (x) { return cloneVNode(x); });
    if (typeof vnode === "object" && vnode !== null) {
        var cvnode = Object.assign({}, vnode);
        if (cvnode.children)
            cvnode.children = cloneVNode(cvnode.children);
        return cvnode;
    }
    return vnode;
};
export var updateIfChanged = function (prop, self, v, o, m) {
    var a = typeof self[prop] === "object" && self[prop] !== null ? self[prop].toString() : self[prop];
    var b = typeof v.attrs[prop] === "object" && v.attrs[prop] !== null ? v.attrs[prop].toString() : v.attrs[prop];
    var c = typeof o.attrs[prop] === "object" && o.attrs[prop] !== null ? o.attrs[prop].toString() : o.attrs[prop];
    if (b !== undefined && a !== b && b !== c) {
        self[prop] = typeof m === "function" ? m(v.attrs[prop]) : v.attrs[prop];
        return true;
    }
    return false;
};
export var portal = function (element, target) {
    if (target === void 0) { target = document.body; }
    var parent = element.parentElement;
    var placeholder = document.createElement("div");
    parent.replaceChild(placeholder, element);
    target.appendChild(element);
    return { reset: function () { return parent.replaceChild(element, placeholder); } };
};
var buttonBounceAttrsTimer;
export var buttonBounceAttrs = function (emit, threshold) {
    if (threshold === void 0) { threshold = 150; }
    var count = 0;
    var enable = debounce(function (e) {
        e.preventDefault();
        emit(count, e);
        count++;
        clearInterval(buttonBounceAttrsTimer);
        buttonBounceAttrsTimer = setInterval(function () {
            if (e.target.disabled)
                return disable(e);
            emit(count, e);
            count++;
        }, threshold);
    }, 10);
    var disable = function (e) {
        e.preventDefault();
        clearInterval(buttonBounceAttrsTimer);
        count = 0;
    };
    return {
        onmousedown: enable,
        ontouchstart: enable,
        onmouseup: disable,
        onmouseleave: disable,
        onmouseout: disable,
        ontouchend: disable,
        ontouchcancel: disable,
    };
};
export var draggableAttrs = function (actions) {
    var pos;
    var getXY = function (e) {
        return e.changedTouches
            ? { x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY }
            : { x: e.pageX, y: e.pageY };
    };
    var stopDrag = function (e) {
        if (pos === undefined)
            return;
        var next = getXY(e);
        var diff = { x: next.x - pos.x, y: next.y - pos.y };
        pos = undefined;
        window.off("mouseup.draggableAttrs");
        window.off("mousemove.draggableAttrs");
        window.off("touchend.draggableAttrs");
        window.off("touchmove.draggableAttrs");
        actions.stop(diff, e);
    };
    var drag = function (e) {
        if (pos === undefined)
            return;
        var next = getXY(e);
        var diff = { x: next.x - pos.x, y: next.y - pos.y };
        actions.drag(diff, function () { return pos = __assign({}, next); }, e);
    };
    var start = function (e) {
        if (!e.changedTouches && e.button !== 0)
            return;
        pos = getXY(e);
        window.on("mouseup.draggableAttrs", function (e) { return stopDrag(e); });
        window.on("mousemove.draggableAttrs", function (e) { return drag(e); });
        window.on("touchend.draggableAttrs", function (e) { return stopDrag(e); }, { passive: false });
        window.on("touchmove.draggableAttrs", function (e) { return drag(e); }, { passive: false });
        actions.start({ x: 0, y: 0 }, e);
    };
    return {
        onmousedown: function (e) { return start(e); },
        ontouchstart: function (e) { return start(e); },
    };
};
export var fileDropAttrs = function (_a) {
    var accept = _a.accept, multiple = _a.multiple, ondrop = _a.ondrop, ondrag = _a.ondrag, onover = _a.onover;
    var totalFiles = [];
    var el;
    var dragging = false;
    var enter = function (e) {
        el = e.target;
        if (dragging === true)
            return;
        dragging = true;
        if (typeof ondrag === "function")
            ondrag(true, e);
    };
    var leave = function (e) {
        if (el.contains(e.fromElement))
            return;
        if (dragging === false)
            return;
        dragging = false;
        if (typeof ondrag === "function")
            ondrag(false, e);
    };
    var drop = function (e) {
        if (!e.dataTransfer || !e.dataTransfer.files)
            return;
        var files = Array.from(e.dataTransfer.files);
        if (accept)
            files = files.filter(function (f) { return isAcceptable(accept, f.name, f.type); });
        if (!multiple) {
            totalFiles = [];
            files.splice(1);
        }
        totalFiles = totalFiles.concat(files);
        ondrop(totalFiles, e);
        if (dragging === false)
            return;
        dragging = false;
        if (typeof ondrag === "function")
            ondrag(false, e);
    };
    var over = function (e) {
        e.preventDefault();
        onover(e);
    };
    return {
        ondrop: function (e) { return drop(e); },
        ondragenter: function (e) { return enter(e); },
        ondragleave: function (e) { return leave(e); },
        ondragover: function (e) { return over(e); }
    };
};
export var animateCreate = function (v, delay) {
    if (delay === void 0) { delay = 20; }
    setTimeout(function () {
        v.dom.classList.remove("animate-in");
        v.state.__animate = true;
    }, delay);
};
export var animateRemove = function (v, delay) {
    if (delay === void 0) { delay = 0; }
    return new Promise(function (r) {
        setTimeout(function () {
            v.dom.classList.add("animate-out");
            v.state.__animate = false;
            setTimeout(r, getTransitionDuration(v.dom));
        }, delay);
    });
};
export var animateClassNames = function (v, animation) {
    return cleanString(animation, v.state.__animate === undefined && "animate-in");
};
//# sourceMappingURL=index.js.map